import { i18n } from '../../i18n/translate.js';
var customerAdminLeft = function customerAdminLeft(environment) {
  var FOUNDRY_KNOWLEDGE_BASE_URL = environment.FOUNDRY_KNOWLEDGE_BASE_URL,
    MENU_DOMAIN_FOR_ADMINIFI = environment.MENU_DOMAIN_FOR_ADMINIFI,
    MENU_DOMAIN_FOR_CONTENT_SERVICE = environment.MENU_DOMAIN_FOR_CONTENT_SERVICE,
    MENU_DOMAIN_FOR_ENGAGE = environment.MENU_DOMAIN_FOR_ENGAGE,
    MENU_DOMAIN_FOR_FRONT_END = environment.MENU_DOMAIN_FOR_FRONT_END,
    MENU_DOMAIN_FOR_NEXT = environment.MENU_DOMAIN_FOR_NEXT;
  var settingsCapabilities = ['Capabilities::WebhookAccess', 'Capabilities::EmbedContent', 'Capabilities::PublicApiAccess', 'Capabilities::SamlSso', 'Capabilities::TagManager'];
  return {
    id: 'foundry--universal_navigation--menus--customer_admin_left',
    type: 'menus',
    slug: 'foundry--universal_navigation--menus--customer_admin_left',
    title: '',
    icon: '',
    font_family: '',
    css_class: '',
    target_url: '',
    target_method: '',
    new_window: false,
    subsection: false,
    submenu_items: [{
      id: '',
      slug: '',
      title: i18n.t('Home'),
      icon: 'house-chimney',
      font_family: '',
      css_class: '',
      target_url: "".concat(MENU_DOMAIN_FOR_FRONT_END, "/{{slug}}/cportal/reports_home"),
      target_method: '',
      new_window: false,
      permissions: [{
        has_rule_set_role: ['he_cc_fs_primary_managers']
      }, {
        has_rule_set: ['advisors']
      }],
      subsection: false,
      submenu_items: [],
      weight: 100
    }, {
      id: 'customizations',
      slug: 'customizations',
      title: i18n.t('Content'),
      icon: 'films',
      font_family: '',
      css_class: '',
      permissions: [{
        has_rule_set_role: ['he_cc_fs_primary_managers']
      }, {
        has_rule_set: [{
          he_cc_fs_scorm_manager_names: 'scorm_manager'
        }]
      }],
      target_url: '',
      target_method: '',
      new_window: false,
      subsection: false,
      submenu_items: [{
        id: '',
        slug: '',
        title: i18n.t('Content Library'),
        icon: 'ban',
        font_family: '',
        css_class: '',
        target_url: "".concat(MENU_DOMAIN_FOR_CONTENT_SERVICE, "/{{slug}}/cportal/content_library"),
        target_method: '',
        new_window: false,
        subsection: false,
        submenu_items: [],
        weight: 100
      }, {
        id: '',
        slug: '',
        title: i18n.t('Resources'),
        icon: 'ban',
        font_family: '',
        css_class: '',
        target_url: "".concat(MENU_DOMAIN_FOR_FRONT_END, "/{{slug}}/cportal/resources"),
        target_method: '',
        new_window: false,
        subsection: false,
        submenu_items: [],
        weight: 100
      }, {
        id: '',
        slug: '',
        title: i18n.t('Policies'),
        icon: 'ban',
        font_family: '',
        css_class: '',
        target_url: "".concat(MENU_DOMAIN_FOR_FRONT_END, "/{{slug}}/cportal/policies"),
        target_method: '',
        new_window: false,
        subsection: false,
        submenu_items: [],
        weight: 100
      }, {
        id: '',
        slug: '',
        title: i18n.t('Scorm Content Packages'),
        icon: 'ban',
        font_family: '',
        css_class: '',
        permissions: [{
          has_rule_set: [{
            he_cc_fs_scorm_manager_names: 'scorm_manager'
          }]
        }],
        target_url: "".concat(MENU_DOMAIN_FOR_FRONT_END, "/{{slug}}/cportal/scorm_packages"),
        target_method: '',
        new_window: false,
        subsection: false,
        submenu_items: [],
        weight: 100
      }],
      weight: 100
    }, {
      id: '',
      slug: '',
      module: 'adminifi',
      title: i18n.t('Users'),
      icon: 'circle-user',
      font_family: '',
      css_class: '',
      permissions: [{
        has_capabilities: ['Capabilities::TeamManagement'],
        has_rule_set: ['next_managers']
      }, {
        has_rule_set: ['he_cc_fs_scorm_manager_names']
      }],
      target_url: '',
      target_method: '',
      new_window: false,
      subsection: false,
      submenu_items: [{
        id: '',
        slug: '',
        title: i18n.t('Manage Users'),
        icon: '',
        font_family: '',
        css_class: '',
        permissions: [{
          has_capabilities: ['Capabilities::TeamManagement'],
          has_rule_set: ['next_managers']
        }, {
          has_rule_set: ['he_cc_fs_scorm_manager_names']
        }],
        target_url: "".concat(MENU_DOMAIN_FOR_ADMINIFI, "/{{slug}}/cportal/users"),
        target_method: '',
        new_window: false,
        subsection: false,
        submenu_items: [],
        weight: 100
      }, {
        id: '',
        slug: '',
        title: i18n.t('Teams'),
        icon: '',
        font_family: '',
        css_class: '',
        permissions: [{
          has_capabilities: ['Capabilities::TeamManagement'],
          has_rule_set_role: ['he_cc_fs_primary_managers']
        }, {
          has_rule_set: ['next_managers']
        }],
        target_url: "".concat(MENU_DOMAIN_FOR_FRONT_END, "/{{slug}}/cportal/teams"),
        target_method: '',
        new_window: false,
        subsection: false,
        submenu_items: [],
        weight: 100
      }, {
        id: '',
        slug: '',
        title: i18n.t('User Uploads'),
        icon: '',
        font_family: '',
        css_class: '',
        permissions: [{
          has_rule_set_role: ['he_cc_fs_primary_managers']
        }, {
          has_rule_set: [{
            next_managers: 'at_work_manager'
          }]
        }],
        target_url: "".concat(MENU_DOMAIN_FOR_ADMINIFI, "/{{slug}}/cportal/user_uploads"),
        target_method: '',
        new_window: false,
        subsection: false,
        submenu_items: [],
        weight: 100
      }, {
        id: '',
        slug: '',
        title: i18n.t('Quick Lists'),
        icon: '',
        font_family: '',
        css_class: '',
        permissions: [{
          has_rule_set: ['he_cc_fs_primary_managers']
        }],
        target_url: "".concat(MENU_DOMAIN_FOR_FRONT_END, "/{{slug}}/cportal/rosters"),
        target_method: '',
        new_window: false,
        subsection: false,
        submenu_items: [],
        weight: 100
      }, {
        id: '',
        slug: '',
        title: i18n.t('Custom Categories'),
        icon: '',
        font_family: '',
        css_class: '',
        permissions: [{
          has_rule_set_role: ['he_cc_fs_primary_managers']
        }, {
          has_rule_set: [{
            next_managers: 'at_work_manager'
          }]
        }],
        target_url: "".concat(MENU_DOMAIN_FOR_FRONT_END, "/{{slug}}/cportal/categories"),
        target_method: '',
        new_window: false,
        subsection: false,
        submenu_items: [],
        weight: 100
      }, {
        id: '',
        slug: '',
        title: i18n.t('Locations'),
        icon: '',
        font_family: '',
        css_class: '',
        permissions: [{
          has_rule_set_role: ['he_cc_fs_primary_managers']
        }, {
          has_rule_set: [{
            next_managers: 'at_work_manager'
          }, {
            he_cc_fs_scorm_manager_names: 'scorm_manager'
          }]
        }],
        target_url: "".concat(MENU_DOMAIN_FOR_FRONT_END, "/{{slug}}/cportal/locations"),
        target_method: '',
        new_window: false,
        subsection: false,
        submenu_items: [],
        weight: 100
      }],
      weight: 100
    }, {
      id: '',
      slug: '',
      module: 'adminifi',
      title: i18n.t('Insights'),
      icon: 'chart-column',
      font_family: '',
      css_class: '',
      permissions: [{
        has_rule_set: ['he_cc_fs_scorm_manager_names']
      }, {
        has_rule_set: ['next_managers']
      }, {
        has_rule_set: ['event_manager_not_cra_content_only']
      }],
      target_url: '',
      target_method: '',
      new_window: false,
      subsection: false,
      submenu_items: [{
        id: '',
        slug: '',
        title: i18n.t('Reports'),
        icon: '',
        font_family: '',
        css_class: '',
        target_url: "".concat(MENU_DOMAIN_FOR_FRONT_END, "/{{slug}}/cportal/reports?force=true"),
        target_method: '',
        new_window: false,
        subsection: false,
        submenu_items: [],
        weight: 100
      }, {
        id: '',
        slug: '',
        title: i18n.t('Data Exports'),
        icon: '',
        font_family: '',
        css_class: '',
        permissions: [{
          has_capabilities: ['Capabilities::DatafiExport'],
          has_rule_set_role: ['he_cc_fs_primary_managers']
        }],
        target_url: "".concat(MENU_DOMAIN_FOR_ADMINIFI, "/{{slug}}/cportal/data_downloads"),
        target_method: '',
        new_window: false,
        subsection: false,
        submenu_items: [],
        weight: 100
      }, {
        id: '',
        slug: '',
        title: i18n.t('Impact Reports'),
        icon: '',
        font_family: '',
        css_class: '',
        permissions: [{
          has_capabilities: ['Capabilities::FileDownloads'],
          has_rule_set_role: ['he_cc_fs_primary_managers']
        }, {
          has_rule_set: [{
            he_cc_fs_scorm_manager_names: 'scorm_manager'
          }]
        }],
        target_url: "".concat(MENU_DOMAIN_FOR_FRONT_END, "/{{slug}}/cportal/downloads"),
        target_method: '',
        new_window: false,
        subsection: false,
        submenu_items: [],
        weight: 100
      }],
      weight: 100
    }, {
      id: '',
      module: 'adminifi',
      slug: '',
      title: i18n.t('Assignments'),
      icon: 'clipboard-check',
      font_family: '',
      css_class: '',
      permissions: [{
        has_rule_set: 'he_cc_fs_manager_names'
      }],
      target_url: "".concat(MENU_DOMAIN_FOR_CONTENT_SERVICE, "/{{slug}}/cportal/assignments"),
      target_method: '',
      new_window: false,
      subsection: false,
      submenu_items: [],
      weight: 100
    }, {
      id: '',
      slug: '',
      title: i18n.t('Resource Center'),
      icon: 'book-reader',
      font_family: '',
      css_class: '',
      permissions: [{
        has_rule_set: [{
          next_managers: 'at_work_manager'
        }]
      }],
      target_url: "https://help.everfi.com/s/adult-financial-education",
      target_method: '',
      new_window: true,
      subsection: false,
      submenu_items: [],
      weight: 100
    }, {
      id: '',
      module: 'next',
      slug: '',
      title: i18n.t('Programs'),
      icon: 'globe',
      font_family: '',
      css_class: '',
      permissions: [{
        has_rule_set: 'advisors',
        not_rule_set: 'next_main_managers'
      }],
      target_url: "".concat(MENU_DOMAIN_FOR_NEXT, "/cportal/programs"),
      target_method: '',
      new_window: false,
      subsection: false,
      submenu_items: [],
      weight: 100
    }, {
      id: '',
      module: 'next',
      slug: '',
      title: i18n.t('Content'),
      icon: 'films',
      font_family: '',
      css_class: '',
      permissions: [{
        has_rule_set: 'next_main_managers'
      }],
      target_url: '',
      target_method: '',
      new_window: false,
      subsection: false,
      weight: 100,
      submenu_items: [{
        id: '',
        module: 'next',
        slug: '',
        title: i18n.t('Playlists'),
        icon: 'globe',
        font_family: '',
        css_class: '',
        target_url: "".concat(MENU_DOMAIN_FOR_NEXT, "/cportal/admin_playlists"),
        target_method: '',
        new_window: false,
        subsection: false,
        submenu_items: [],
        weight: 100
      }, {
        id: '',
        module: 'next',
        slug: '',
        title: i18n.t('Programs'),
        icon: 'globe',
        font_family: '',
        css_class: '',
        target_url: "".concat(MENU_DOMAIN_FOR_NEXT, "/cportal/programs"),
        target_method: '',
        new_window: false,
        subsection: false,
        submenu_items: [],
        weight: 100
      }]
    }, {
      id: '',
      module: 'engage',
      slug: '',
      title: i18n.t('Event Content'),
      icon: 'calendar-check',
      font_family: '',
      css_class: '',
      permissions: [{
        has_capabilities: ['Capabilities::CRAEducation'],
        has_rule_set: ['engage_managers']
      }],
      target_url: '',
      target_method: '',
      new_window: false,
      subsection: false,
      weight: 100,
      submenu_items: [{
        id: '',
        module: 'engage',
        slug: '',
        title: i18n.t('Volunteers'),
        icon: '',
        font_family: '',
        css_class: '',
        target_url: "".concat(MENU_DOMAIN_FOR_ENGAGE, "/cportal/volunteers"),
        target_method: '',
        new_window: false,
        subsection: false,
        submenu_items: [],
        weight: 100
      }, {
        id: '',
        module: 'engage',
        slug: '',
        title: i18n.t('Work Locations'),
        icon: '',
        font_family: '',
        css_class: '',
        target_url: "".concat(MENU_DOMAIN_FOR_ENGAGE, "/cportal/work_locations"),
        target_method: '',
        new_window: false,
        subsection: false,
        submenu_items: [],
        weight: 100
      }, {
        id: '',
        module: 'engage',
        slug: '',
        title: i18n.t('Workshop Topics'),
        icon: '',
        font_family: '',
        css_class: '',
        target_url: "".concat(MENU_DOMAIN_FOR_ENGAGE, "/cportal/topics"),
        target_method: '',
        new_window: false,
        subsection: false,
        submenu_items: [],
        weight: 100
      }]
    }, {
      id: '',
      module: 'engage',
      slug: '',
      title: i18n.t('Manage Events'),
      icon: 'calendar-check',
      font_family: '',
      css_class: '',
      permissions: [{
        has_capabilities: ['Capabilities::EventManagement'],
        has_rule_set: ['engage_managers']
      }],
      target_url: '',
      target_method: '',
      new_window: false,
      subsection: false,
      weight: 100,
      submenu_items: [{
        id: '',
        module: 'engage',
        slug: '',
        title: i18n.t('Events'),
        icon: '',
        font_family: '',
        css_class: '',
        target_url: "".concat(MENU_DOMAIN_FOR_ENGAGE, "/cportal/events"),
        target_method: '',
        new_window: false,
        subsection: false,
        submenu_items: [],
        weight: 100
      }, {
        id: '',
        module: 'engage',
        slug: '',
        title: i18n.t('Volunteers'),
        icon: '',
        font_family: '',
        css_class: '',
        target_url: "".concat(MENU_DOMAIN_FOR_ENGAGE, "/cportal/volunteers"),
        target_method: '',
        new_window: false,
        subsection: false,
        permissions: [{
          not_capabilities: ['Capabilities::EventManagement'],
          has_rule_set: ['engage_managers']
        }],
        submenu_items: [],
        weight: 100
      }, {
        id: '',
        module: 'engage',
        slug: '',
        title: i18n.t('Attendees'),
        icon: '',
        font_family: '',
        css_class: '',
        target_url: "".concat(MENU_DOMAIN_FOR_ENGAGE, "/cportal/attendees"),
        target_method: '',
        new_window: false,
        subsection: false,
        submenu_items: [],
        weight: 100
      }, {
        id: '',
        module: 'engage',
        slug: '',
        title: i18n.t('Workshop Topics'),
        icon: '',
        font_family: '',
        css_class: '',
        target_url: "".concat(MENU_DOMAIN_FOR_ENGAGE, "/cportal/topics"),
        target_method: '',
        new_window: false,
        subsection: false,
        submenu_items: [],
        weight: 100
      }, {
        id: '',
        module: 'engage',
        slug: '',
        title: i18n.t('Venues'),
        icon: '',
        font_family: '',
        css_class: '',
        target_url: "".concat(MENU_DOMAIN_FOR_ENGAGE, "/cportal/venues"),
        target_method: '',
        new_window: false,
        subsection: false,
        submenu_items: [],
        weight: 100
      }, {
        id: '',
        module: 'engage',
        slug: '',
        title: i18n.t('Work Locations'),
        icon: '',
        font_family: '',
        css_class: '',
        permissions: [{
          not_capabilities: ['Capabilities::EventManagement'],
          has_rule_set: ['engage_managers']
        }],
        target_url: "".concat(MENU_DOMAIN_FOR_ENGAGE, "/cportal/work_locations"),
        target_method: '',
        new_window: false,
        subsection: false,
        submenu_items: [],
        weight: 100
      }, {
        id: '',
        module: 'engage',
        slug: '',
        title: i18n.t('Partners'),
        icon: '',
        font_family: '',
        css_class: '',
        target_url: "".concat(MENU_DOMAIN_FOR_ENGAGE, "/cportal/partners"),
        target_method: '',
        new_window: false,
        subsection: false,
        submenu_items: [],
        weight: 100
      }, {
        id: '',
        module: 'engage',
        slug: '',
        title: i18n.t('Settings'),
        icon: '',
        font_family: '',
        css_class: '',
        permissions: [{
          has_rule_set: ['engage_managers']
        }],
        target_url: "".concat(MENU_DOMAIN_FOR_ENGAGE, "/cportal/settings"),
        target_method: '',
        new_window: false,
        subsection: false,
        submenu_items: [],
        weight: 100
      }]
    }, {
      id: '',
      slug: '',
      module: 'notifi',
      title: i18n.t('Communications'),
      icon: 'bell-on',
      font_family: '',
      css_class: '',
      permissions: [{
        has_rule_set_role: ['he_cc_fs_primary_managers']
      }],
      target_url: "".concat(MENU_DOMAIN_FOR_FRONT_END, "/{{slug}}/cportal/templates"),
      target_method: '',
      new_window: false,
      subsection: false,
      submenu_items: [],
      weight: 100
    }, {
      id: '',
      module: 'homeroom',
      slug: '',
      title: i18n.t('Content'),
      icon: 'films',
      font_family: '',
      css_class: '',
      permissions: [{
        has_rule_set: ['k12']
      }],
      target_url: '',
      target_method: '',
      new_window: false,
      subsection: false,
      weight: 100,
      submenu_items: [{
        id: '',
        module: 'homeroom',
        slug: '',
        title: i18n.t('Content Library'),
        icon: '',
        font_family: '',
        css_class: '',
        target_url: "".concat(MENU_DOMAIN_FOR_CONTENT_SERVICE, "/{{slug}}/cportal/content_library"),
        target_method: '',
        new_window: false,
        subsection: false,
        submenu_items: [],
        weight: 100
      }]
    }, {
      id: '',
      slug: '',
      title: i18n.t('Settings'),
      icon: 'gear',
      font_family: '',
      css_class: '',
      permissions: [{
        has_capabilities: settingsCapabilities,
        has_rule_set: [{
          next_managers: 'at_work_manager'
        }, {
          next_managers: 'pii_restricted_next_primary'
        }]
      }, {
        has_capabilities: settingsCapabilities,
        not_rule_set: ['advisors']
      }, {
        has_capabilities: settingsCapabilities,
        has_rule_set: ['event_manager', 'event_manager_not_cra_content_only']
      }, {
        has_capabilities: settingsCapabilities,
        has_rule_set_role: ['he_cc_fs_primary_managers']
      }, {
        not_capabilities: ['Capabilities::LegacyAssignments'],
        has_rule_set: ['he_cc_fs_manager_names']
      }],
      target_url: '',
      target_method: '',
      new_window: false,
      subsection: false,
      submenu_items: [{
        id: '',
        slug: '',
        title: i18n.t('Training Periods'),
        icon: '',
        font_family: '',
        css_class: '',
        permissions: [{
          not_capabilities: ['Capabilities::LegacyAssignments'],
          has_rule_set: ['he_cc_fs_manager_names']
        }],
        target_url: "".concat(MENU_DOMAIN_FOR_FRONT_END, "/{{slug}}/cportal/training_periods"),
        target_method: '',
        new_window: false,
        subsection: false,
        submenu_items: [],
        weight: 100
      }, {
        id: '',
        slug: '',
        title: i18n.t('Single Sign-on'),
        icon: '',
        font_family: '',
        css_class: '',
        permissions: [{
          has_capabilities: ['Capabilities::SamlSso'],
          has_rule_set: [{
            next_managers: 'at_work_manager'
          }]
        }, {
          has_capabilities: ['Capabilities::SamlSso'],
          has_rule_set: [{
            next_managers: 'pii_restricted_next_primary'
          }]
        }, {
          has_capabilities: ['Capabilities::SamlSso'],
          has_rule_set: 'event_manager_not_cra_content_only'
        }, {
          has_capabilities: ['Capabilities::SamlSso'],
          has_rule_set_role: ['he_cc_fs_primary_managers']
        }],
        target_url: "".concat(MENU_DOMAIN_FOR_FRONT_END, "/{{slug}}/cportal/identity_providers"),
        target_method: '',
        new_window: false,
        subsection: false,
        submenu_items: [],
        weight: 100
      }, {
        id: '',
        slug: '',
        title: i18n.t('Embed Content'),
        icon: '',
        font_family: '',
        css_class: '',
        permissions: [{
          has_capabilities: ['Capabilities::EmbedContent'],
          has_rule_set: {
            next_managers: 'at_work_manager'
          }
        }],
        target_url: "".concat(MENU_DOMAIN_FOR_ADMINIFI, "/{{slug}}/cportal/embed_content"),
        target_method: '',
        new_window: false,
        subsection: false,
        submenu_items: [],
        weight: 100
      }, {
        id: '',
        slug: '',
        title: i18n.t('Data Integration'),
        icon: '',
        font_family: '',
        css_class: '',
        permissions: [{
          has_capabilities: ['Capabilities::PublicApiAccess'],
          has_rule_set: ['he_cc_fs_manager_names']
        }, {
          has_capabilities: ['Capabilities::PublicApiAccess'],
          has_rule_set: [{
            engage_managers: 'event_manager'
          }]
        }, {
          has_capabilities: ['Capabilities::PublicApiAccess'],
          has_rule_set: [{
            next_managers: 'at_work_manager'
          }]
        }],
        target_url: "".concat(MENU_DOMAIN_FOR_FRONT_END, "/{{slug}}/cportal/data_integration"),
        target_method: '',
        new_window: false,
        subsection: false,
        submenu_items: [],
        weight: 100
      }, {
        id: '',
        slug: '',
        title: i18n.t('Webhooks'),
        icon: '',
        font_family: '',
        css_class: '',
        permissions: [{
          has_capabilities: ['Capabilities::WebhookAccess'],
          has_rule_set: ['he_cc_fs_manager_names']
        }, {
          has_capabilities: ['Capabilities::WebhookAccess'],
          has_rule_set: [{
            next_managers: 'at_work_manager'
          }]
        }],
        target_url: "".concat(MENU_DOMAIN_FOR_FRONT_END, "/{{slug}}/cportal/webhooks"),
        target_method: '',
        new_window: false,
        subsection: false,
        submenu_items: [],
        weight: 100
      }, {
        id: '',
        slug: '',
        title: i18n.t('Tag Manager'),
        icon: '',
        font_family: '',
        css_class: '',
        permissions: [{
          has_capabilities: ['Capabilities::TagManager'],
          has_rule_set: [{
            next_managers: 'at_work_manager'
          }]
        }],
        target_url: "".concat(MENU_DOMAIN_FOR_ADMINIFI, "/{{slug}}/cportal/tag_manager"),
        target_method: '',
        new_window: false,
        subsection: false,
        submenu_items: [],
        weight: 100
      }],
      weight: 9999
    }, {
      id: '',
      slug: '',
      title: i18n.t('Help'),
      icon: 'circle-question',
      font_family: '',
      css_class: '',
      permissions: [{
        has_rule_set: ['he_cc_fs_scorm_manager_names']
      }, {
        has_rule_set: ['k12']
      }],
      help_url_post_processing: true,
      foundryKnowledgeBaseUrl: FOUNDRY_KNOWLEDGE_BASE_URL,
      target_url: 'https://resources.everfi.com/help/',
      target_method: '',
      new_window: true,
      subsection: false,
      submenu_items: [],
      weight: 100
    }]
  };
};
export { customerAdminLeft };